export default __webpack_public_path__ + "static/media/greystar.cd8ba0e2.svg";